(function () {
    const LOGGER_PREFIX = 'NVZN3D';
    const nvznAppData = JSON.parse(document.getElementById('nvzn-app-data').textContent);
    if (!nvznAppData) return console.error(`[${LOGGER_PREFIX}] nvznAppData not found`);
    if (nvznAppData.app.logging) console.log(`[${LOGGER_PREFIX}] nvznAppData:`, nvznAppData);

    function init() {
        if (document.readyState === 'loading') return document.addEventListener('DOMContentLoaded', init, { once: true });
        document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
            button.addEventListener('click', function () {
                const selectedVariant = getSelectedVariant();
                if (!selectedVariant) return console.error(`[${LOGGER_PREFIX}] Unable to determine selected variant`);
                const nvznId = nvznAppData?.product?.nvznId;
                if (!nvznId) return console.error(`[${LOGGER_PREFIX}] NvznId not found in product metafields`);
                const materialVariantId = selectedVariant.materialId || null;
                if (nvznAppData.app.logging) {
                    console.log(`[${LOGGER_PREFIX}] selectedVariant:`, selectedVariant);
                    console.log(`[${LOGGER_PREFIX}] nvznId:`, nvznId);
                    console.log(`[${LOGGER_PREFIX}] materialVariantId:`, materialVariantId);
                }
                window.Nvzn3D.display3DPreview({
                    nvznId,
                    materialVariantId
                });
            });
        });
    }

    function getSelectedVariant() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant') || nvznAppData.product.selectedOrFirstAvailableVariantId.toString();
        if (!variantId) return console.error(`[${LOGGER_PREFIX}] Unable to determine variant ID`);
        const variant = nvznAppData.product.variants.find((v) => v.id.toString() === variantId);
        if (!variant) return console.error(`[${LOGGER_PREFIX}] Variant with ID ${variantId} not found`);
        return variant || null;
    }

    init();
})();